module.exports = __webpack_public_path__ + "img/mobile-elbow-1_52x68.c2ff2fdb.png";